import { Navigation } from './04_layout/navigation/navigation';
import { OnePageNavigation } from './04_layout/navigation/one-page-navigation';
import { Logger } from './02_utils/logger';
import { Slider } from './05_components/slider/slider';
import { GoogleMap } from './05_components/map/googleMap';
import { Utils } from './02_utils/utils';
import { Base } from './01_base/base';
import { ToTop } from './04_layout/to-top/to-top';
import { Counter } from './02_utils/counter';
import { CookieHelper } from './02_utils/cookieHelper';
import { Video } from './05_components/video/video';
import { SidePanel } from './04_layout/side-panel/side-panel';
import { Panel } from './04_layout/side-panel/panel';
import { SidePanelService } from './04_layout/side-panel/services/sidePanelService';
import { PanelService } from './04_layout/side-panel/services/panelService';
import { ModelViewer } from './05_components/modelViewer/modelViewer';
import { BackLink } from './04_layout/backLink/backLink';
import { Form } from './03_elements/form/form';

export class Main {
  constructor() {
    const logger = new Logger();
    const utils = new Utils(logger);
    const base = new Base(logger, utils);
    const cookieHelper = new CookieHelper(logger);
    const sidePanelService = new SidePanelService(logger, utils);
    const panelService = new PanelService(logger, utils);

    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight;
    new Base(logger, utils, headerHeight);
    new ToTop(logger, utils, 10);
    new Navigation(logger, utils);
    new OnePageNavigation(logger, utils, base);
    new Slider(logger);
    new GoogleMap(logger);
    new Counter(logger, utils);
    new Video(logger);
    new SidePanel(logger, sidePanelService);
    new Panel(logger, panelService);
    new ModelViewer(logger, utils);
    new BackLink();
    new Form();
  }
}
